// extracted by mini-css-extract-plugin
module.exports = {"exhibition_title":"banner_exhibition_title__EcEzk","description":"banner_description__l_wIH","summary":"banner_summary__EHXkR","card":"banner_card__LJItH"};